/**
 * O "Ativo" da tela de usuários (spec 042) — a lógica pura, sem React, para
 * ser provada fora do navegador (o teste mora na API,
 * apps/api/src/shared/user-access-notice.test.ts).
 *
 * "Ativo" é o acesso da pessoa A ESTA empresa. Quando era o último acesso dela,
 * a API desliga também a conta de login (e encerra as sessões); quando o SSO
 * não responde, o acesso a esta empresa já vale, e a conta fica como estava —
 * a resposta diz qual dos casos foi (`account`), e a tela diz ao admin.
 */
import type { AccountChange } from '@erp/shared';

export interface AccessNotice {
  tone: 'info' | 'error';
  text: string;
  /** true: o diálogo fica aberto — salvar de novo tenta a conta outra vez */
  keepOpen: boolean;
}

/** O aviso depois de salvar; null = nada além do normal (o diálogo fecha). */
export function accountChangeNotice(name: string, change: AccountChange | undefined): AccessNotice | null {
  const who = name.trim() || 'esta pessoa';
  switch (change) {
    case 'disabled':
      return {
        tone: 'info',
        text: `Era o último acesso de ${who}: a conta de login foi desligada e as sessões abertas, encerradas.`,
        keepOpen: false,
      };
    case 'enabled':
      return { tone: 'info', text: `A conta de login de ${who} foi religada.`, keepOpen: false };
    case 'disable_failed':
      return {
        tone: 'error',
        text: `O acesso de ${who} a esta empresa foi encerrado, mas o SSO não desligou a conta de login. Salve de novo para tentar.`,
        keepOpen: true,
      };
    case 'enable_failed':
      return {
        tone: 'error',
        text: `O acesso a esta empresa foi religado, mas o SSO não religou a conta de login — ${who} ainda não entra. Salve de novo para tentar.`,
        keepOpen: true,
      };
    default:
      return null;
  }
}
